import { render, staticRenderFns } from "./select_changetypes.vue?vue&type=template&id=1463045a&scoped=true"
import script from "./select_changetypes.vue?vue&type=script&lang=js"
export * from "./select_changetypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463045a",
  null
  
)

export default component.exports